<footer>
    <div [@animateFooter]>
        <ul class="footer-left-bar d-none d-md-block">
            <li>
                <a (click)='analyticsService.sendAnalyticEvent("click_github", "footer", "github")' href="https://github.com/XXXXXXXXX" target='_blank'>
                    <i class="fab fa-github"></i>
                </a>
            </li>
           
        </ul>
        <div class="footer-right-bar d-none d-md-block">
            <a (click)='analyticsService.sendAnalyticEvent("click_send_mail", "footer", "email")' href="mailto:testmail@mail.com" target='_blank'>testmail@mail.com </a>
        </div>
    </div>

    <div class="footer-credits text-center" >
        <a (click)='analyticsService.sendAnalyticEvent("click_github_portfolio", "footer", "click")' href="https://github.com/XXXXXXXXX" target="_blank" rel="nofollow noopener noreferrer">
            <div>apellido - nombre</div>
        </a>
    </div>

</footer>